import { getCustomerByContactId } from "@api";
import { Logo, PageLoader, ProgressBar } from "@components";
import { usePostHogIdentify } from "@hooks";
import { useEffect, useState } from "react";
import {
  Outlet,
  useMatches,
  useNavigate,
  useSearchParams,
} from "react-router-dom";

const EmbeddedAccountPayment = () => {
  const [searchParams] = useSearchParams();
  const contactId = searchParams.get("cu"); // customerCOntactId

  const matches = useMatches();
  const navigate = useNavigate();
  const routeId = matches[matches.length - 1].id;

  const [customer, setCustomer] = useState(null);
  const [payment, setPayment] = useState(null);
  const [paymentParameters, setPaymentParameters] = useState(null);
  const [methodStepData, setMethodStepData] = useState();

  // Use PostHog identification hook

  // usePostHogIdentify({
  //   customerId: paymentParameters?.customerId,
  //   customerName: paymentParameters?.customerName,
  //   merchantId: paymentParameters?.merchantId,
  //   merchantName: customer?.merchant?.name,
  // }, !!paymentParameters);

  const progressMap = {
    "eap-paymentdetails": "20%",
    "eap-choosepaymentmethod": "40%",
    "eap-confirmpaybybank": "60%",
    "eap-success": "full",
    "eap-processing": "80%",
  };

  const load = async () => {
    const customerData = await getCustomerByContactId(contactId);
    setCustomer(customerData);

    setPaymentParameters({
      merchantId: customerData.merchant.id,
      customerId: customerData.id,
      customerName: customerData.name,
      customerEmail: customerData.email,
      amount: customerData.balance,
      reference: customerData.accountCode,
      amexPaymentAllowed: customerData.merchant.allowAmex,
      source: "EmbeddedTradeCustomerCheckout",
      customerIsFinanced: customerData.isFinanced,
      preventRedirect: true,
      cardPaymentAllowed: true,
      cardPaymentProvider: customerData.merchant.cardPaymentProvider,
    });
  };

  useEffect(() => {
    load();
  }, []);

  // todo,
  return customer ? (
    <div className="lg:h-dvh lg:flex lg:flex-col">
      <div className="sticky top-0">
        <div className="bg-white flex items-center justify-center py-2 h-[68px]">
          <Logo merchant={customer.merchant} />
        </div>
        <ProgressBar
          merchant={customer.merchant}
          width={progressMap[routeId]}
        />
      </div>
      <Outlet
        context={{
          contactId,
          customer,
          setMethodStepData,
          setPaymentParameters,
          paymentParameters,
          methodStepData,
          setPayment,
          payment,
        }}
      />
    </div>
  ) : (
    <PageLoader />
  );
};

export default EmbeddedAccountPayment;
